import SearchForm from '../../model/search-form';

export default class DeliveryNoteSearchForm implements SearchForm {

  private readonly submittedDateFrom: JQuery;
  private readonly submittedDateUntil: JQuery;
  private readonly id: JQuery;
  private readonly submitBtn: JQuery;
  private readonly locationRadio: JQuery;
  private readonly multiselect: JQuery;

  constructor(private form: JQuery<HTMLFormElement>) {
    this.submittedDateFrom = this.form.find('.js-submittedDateFrom');
    this.submittedDateUntil = this.form.find('.js-submittedDateUntil');
    this.id = this.form.find('.js-id');
    this.submitBtn = this.form.find('.js-submitBtn');
    this.locationRadio = this.form.find('.js-locationRadio');
    this.multiselect = this.form.find('.js-multiselect');

    const datepickerOptions = { maxDate: '0D' };
    this.submittedDateFrom.datepicker('option', datepickerOptions);
    this.submittedDateUntil.datepicker('option', datepickerOptions);

    this.prepareForm();
    this.bindValidateForm();
    this.bindLocationRadioChange();
  }

  getForm(): JQuery<HTMLFormElement> {
    return this.form;
  }

  submit(): void {
    this.form.submit();
  }

  private bindValidateForm(): void {
    this.form.on('change', () => {
      this.prepareForm();
    });
  }

  private prepareForm(): void {
    this.submitBtn.prop('disabled', !this.isFormValid());
  }

  private isFormValid(): boolean {
    if ((this.id.val() !== '' && this.submittedDateFrom.val() === '' && this.submittedDateUntil.val() === '')
      || (this.submittedDateFrom.val() !== '' && this.submittedDateUntil.val() !== '')) {
      return true;
    }

    return false;
  }

  private bindLocationRadioChange(): void {
    this.locationRadio.on('change', (e): void => {
      if ($(e.currentTarget).val() === 'false') {
        this.multiselect.removeClass('d-none');
      } else {
        this.multiselect.addClass('d-none');
        this.multiselect.val('');
      }
    });
  }
}
